import React, { useEffect } from 'react';
import { Container, Card, Row, Col } from 'react-bootstrap';

export default function Education() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="wrapper d-flex flex-column min-vh-100" style={{backgroundColor:'#f5f6ff'}}>
      <div className="details flex-grow-1">

        <Container>
          <Row className="g-3 g-md-5 mt-1">
            <Col xs={12} md={4}>
              <Card className="bg-light hover-card h-100">
                <Card.Body>
                  <h2 className="mb-4">Graduation</h2>
                  <Card.Title>B.TECH (Electrical & Electronics Engineering) - 2023</Card.Title>
                  <Card.Text>Indur Institute of Engineering & Technology</Card.Text>
                  <Card.Text className="fw-bold">CGPA: 7.11</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="bg-light hover-card h-100">
                <Card.Body>
                  <h2 className="mb-4">Diploma / 10+2</h2>
                  <Card.Title>DIPLOMA (Electrical & Electronics Engineering) - 2020</Card.Title>
                  <Card.Text>Indur Institute of Engineering & Technology</Card.Text>
                  <Card.Text className="fw-bold">Percentage: 74.13%</Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col xs={12} md={4}>
              <Card className="bg-light hover-card h-100">
                <Card.Body>
                  <h2 className="mb-4">MATRICULATION - 2017</h2>
                  <Card.Text>T.S. Model School</Card.Text>
                  <Card.Text className="fw-bold">CGPA: 7.8</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Footer */}
      <footer className="foot bg-secondary text-white p-3 mt-2">
      <Container className="px-0">
      <Row className="justify-content-center align-items-center">
        <Col xs={12} sm={4} className="mb-3 mb-sm-0 text-center text-sm-start">
          <h6>Designed & Developed by <a href="https://www.linkedin.com/in/arenaveenkumar" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}><strong className='text-warning'>ARE NAVEEN KUMAR</strong></a></h6>
        </Col>
        <Col xs={12} sm={4} className="text-center mb-4 mb-sm-0">
          <h6 className="mb-0"><i className="fa-regular fa-copyright "></i> Copyright-2024</h6>
        </Col>
        <Col xs={12} sm={4} className="d-flex justify-content-center justify-content-sm-end">
          <a href="https://www.linkedin.com/in/arenaveenkumar/" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-linkedin-in fs-4"></i></a>
          <a href="https://github.com/arenaveenkumar" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-github fs-4"></i></a>
          <a href="https://www.instagram.com/arenaveenkumar_" className="text-white me-3" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-instagram fs-4"></i></a>
          <a href="https://wa.me/918096858075" className="text-white" target="_blank" rel="noopener noreferrer"><i className="fa-brands fa-whatsapp fs-4"></i></a>

        </Col>
      </Row>
    </Container>
      </footer>
    </div>
  );
}
